import React from "react";
import InstagramIcon from "../../assets/icons/Instagram.png";
import TelegramIcon from "../../assets/icons/Telegram.png";
import LinkedInIcon from "../../assets/icons/LinkedIn.png";

const FooterIcons = () => {
  return (
    <ul>
      <li>
        <a>
          <img src={LinkedInIcon} />
        </a>
      </li>
      <li>
        <a>
          <img src={TelegramIcon} />
        </a>
      </li>
      <li>
        <a>
          <img src={InstagramIcon} />
        </a>
      </li>
    </ul>
  );
};

export default FooterIcons;
